export enum SendFormsOrigin {
  FORMS,
  CONTACTS,
  COMPLETE,
  KIOSK,
  NONE,
}

export enum SendFormStep {
  SELECT_CONTACT,
  SELECT_APPOINTMENT,
  SELECT_DELIVERY_METHOD,
  SELECT_DOCUMENT,
  SELECTED_MESSAGE_MODE,
  SELECT_LOCATION,
}

export type DeliveryMethod = 'email' | 'message' | 'kiosk';
export enum ContactNumberType {
  HOME,
  MOBILE,
  WORK,
}
